/* This file is autogenerated, see readme.md for instructions */
import BracketsSvgIcon from '@bloomreach/banana-theme/icons/brackets.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const BracketsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <BracketsSvgIcon />
    </Icon>
  );
});

BracketsIcon.displayName = 'BracketsIcon';

export default BracketsIcon;
